module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_06.160647c9.jpg";